import _ from 'lodash';
import React from 'react';
import autobind from 'autobind-decorator';
import { inject, observer } from 'mobx-react';
import { toJS } from 'mobx';
import ReactModal from 'react-modal';
import { toast } from 'react-toastify';

import config from 'client/shared/config';

import { addStore } from '../../util';
import FieldFactory from '../field-factory';
import Editor from '../editor';
import ReactHintFactory from 'react-hint'
const ReactHint = ReactHintFactory(React)


const FIELD_KEY_MAP = {
	firstName: 'user.firstName',
	lastName: 'user.lastName',
	name: 'artist.name',
	email: 'user.email',
	userName: 'user.userName',
	password: 'user.password',
	confirmPassword: 'user.confirmPassword',
	phoneNumber: 'user.phoneNumber',
	genre: 'artist.genre',
	paymentServiceID: 'artist.paymentServiceID',
	dob: 'user.dob',
	hfmPicksOptIn: 'artist.hfmPicksOptIn',
	location: 'user.location'
};

@inject('formStore')
@observer
class PasswordInfo extends React.Component {
	render () {
		const { formStore, isPasswordBox } = this.props;
		const passwordValid = formStore.validation[FIELD_KEY_MAP.password];
		const passwordsMatch = formStore.validation[FIELD_KEY_MAP.confirmPassword];
		
		return (
			<Fragment>
				{(passwordValid && isPasswordBox) && ( 
					<div data-rh='' style={{position:'absolute', top: '25%', right: '-10%'}}>
						<i 
							className="fas fa-question-circle" 
							style={{color:"#09be31"}}
						/>
					</div>
				)}
				{(!passwordValid && isPasswordBox) && ( 
					<div data-rh='' style={{position:'absolute', top: '25%', right: '-10%'}}>
						<i 
							className="fas fa-question-circle" 
							style={{color: "#ea0000"}}
						/>
					</div>
				)}
				{(passwordsMatch && !isPasswordBox) && ( 
					<div data-rh='Passwords match!' style={{position:'absolute', top: '25%', right: '-10%'}}>
						<i 
							className="fas fa-check-circle" 
							style={{color:"#09be31"}}
						/>
					</div>
				)}
				{(!passwordsMatch && !isPasswordBox) && ( 
					<div data-rh='Passwords do not match.' style={{position:'absolute', top: '25%', right: '-10%'}}>
						<i 
							className="fas fa-check-circle" 
							style={{color:"#ea0000"}}
						/>
					</div>
				)}
			</Fragment>
		)
	}
}

@inject('genreStore', 'formStore', 'userStore', 'artistStore')
@observer
class AccountCreationForm extends React.Component {
	constructor (props) {
		super(props);

		const { userStore, artistStore } = this.props;

		userStore.clearDataItem();
		artistStore.clearDataItem();

		artistStore.set({
			key: 'hfmPicksOptIn',
			value: true
		});

		artistStore.set({
			key: 'scoreMatrix',
			value: []
		});
	}

	componentDidMount () {
		document.addEventListener('keypress', this.onKeyPress);
	}

	componentWillUnmount () {
		document.removeEventListener('keypress', this.onKeyPress);
	}

	render () {
		const { userStore, artistStore, formStore, genreStore } = this.props;
		const FieldWithStore = addStore(FieldFactory, { formStore });

		const Field = (props) => (
			<FieldWithStore
				{ ...props }
				noFieldClass
				onChange={ this.onChange } />
		);

		return (
			<div className="grid-x">
				<div className="cell">
					<div className="grid-x grid-padding-x">
						<ReactHint events={ { hover: true } } position="right" onRenderContent={(e) => this.renderPasswordReq(e)} persist />
						<div className="cell small-12 padding-bottom-0">
							<h5>Your Information:</h5>
						</div>

						<div className="cell small-6">
							<Field
								store={ userStore }
								fieldKey={ FIELD_KEY_MAP.firstName }
							/>
						</div>
						<div className="cell small-6">
							<Field
								store={ userStore }
								fieldKey={ FIELD_KEY_MAP.lastName }
							/>
						</div>
					</div>

					<div className="grid-x grid-padding-x">
						<div className="cell small-6">
							<Field
								store={ artistStore }
								fieldKey={ FIELD_KEY_MAP.name }
							/>
						</div>
						<div className="cell small-6">
							<Field
								store={ userStore }
								fieldKey={ FIELD_KEY_MAP.email }
							/>
						</div>
					</div>

					<div style={{position:"relative"}}>
						<div className="grid-x align-middle">
							<Field 
								fieldKey={ FIELD_KEY_MAP.password }
								placeholder='Password'
								label=''
							/>
						<PasswordInfo isPasswordBox={true} />
						</div>
					</div>
					<div style={{position:"relative"}}>
					<div className="grid-x align-middle">
						<Field
							fieldKey={ FIELD_KEY_MAP.confirmPassword }
							validate={ this.validateConfirmPassword }
							placeholder='Confirm Password'
							label=''
						/>
						<PasswordInfo isPasswordBox={false} />
						</div>
					</div>

					<PasswordInfo />

					<div className="grid-x grid-padding-x">
						<div className="cell small-6">
							<Field
								store={ userStore }
								fieldKey={ FIELD_KEY_MAP.phoneNumber }
							/>
						</div>
						<div className="cell small-6" data-ta="genreSelect">
							<Field
								store={ artistStore }
								optionsStore={ genreStore } fieldKey={ FIELD_KEY_MAP.genre }
							/>
						</div>
					</div>

					<div className="grid-x grid-padding-x">
						<div className="cell small-6">
							<Field
								store={ artistStore }
								fieldKey={ FIELD_KEY_MAP.paymentServiceID }
							/>
						</div>
						<div className="cell small-6">
							<Field
								store={ userStore }
								fieldKey={ FIELD_KEY_MAP.dob }
							/>
						</div>
					</div>

					<div className="grid-x grid-padding-x">
						<div className="cell small-12">
							<p><a href={ config.stripeRegister } target="_blank">Click here to create a Stripe account.</a></p>
						</div>
					</div>

					<div className="grid-x grid-padding-x">
						<div className="cell small-6">
							<Field
								store={ userStore }
								fieldKey={ FIELD_KEY_MAP.location }
							/>
						</div>
						<div className="cell small-6">
							<Field
								floatLabel
								store={ artistStore }
								fieldKey={ FIELD_KEY_MAP.hfmPicksOptIn }
							/>
						</div>
					</div>
				</div>
			</div>
		);
	}

	renderPasswordReq (e) {
		let defaultRh = e.getAttribute('data-rh')

		if(defaultRh.length > 0) {
			return (
				<div style={{width:'25vw',
					textAlign:'left', 
					boxShadow:`6px 6px 13px -3px #000000`, padding: '0.5vw',
					backgroundColor: "#381648"}}>
					{defaultRh}
				</div>
			)
		}
		return (
			<div style={{width:'25vw',
				textAlign:'left', 
				boxShadow:`6px 6px 13px -3px #000000`, padding: '0.5vw',
				backgroundColor: "#381648"}}>
				Your password must:<br/>
				<ul style={{listStyleType:'none'}}>
					<li>Be at least 8 characters long</li>
					<li>Contain at least one uppercase letter</li>
					<li>Contain at least one number</li>
					<li>Contain at least one special character</li>
					<li>Not contain sequences of three or more repeated characters</li>
				</ul>
			</div>
		)

	}

	@autobind
	validateConfirmPassword (confirmPassword, key) {
		const { formStore, userStore } = this.props;
		const value = {
			confirmPassword,
			password: userStore.get(FIELD_KEY_MAP.password)
		};

		return formStore.validate(value, key);
	}

	@autobind
	onChange (key, value) {
		const { formStore, userStore, artistStore } = this.props;

		let isValid = formStore.validateFields(_.values(FIELD_KEY_MAP), (key) => {
			const store = (/^user/).test(key) ? userStore : artistStore;
			const value = store.get(key);

			if (key === FIELD_KEY_MAP.confirmPassword) {

				return {
					confirmPassword: value,
					password: userStore.get(FIELD_KEY_MAP.password)
				};
			}

			return value;
		});

		formStore.setValidation({
			accountCreationForm: isValid
		});

		if (key === FIELD_KEY_MAP.email) {

			userStore.set({ value, key: FIELD_KEY_MAP.userName });
		}
	}
}

export default AccountCreationForm;
